"use client";

import { Tooltip, cn } from "@tosize/ui";
import Image from "~/components/utilities/Image";
import { useRouter } from "~/hooks/useRouter";

interface MaterialItemProps {
	image: string;
	imageWatermark?: string;
	materialName: string;
	productName?: string;
	subtitle?: string;
	url: string;
	variant?: "shades" | "secondary" | "default";
}

export function MaterialItem(props: MaterialItemProps) {
	const {
		image,
		imageWatermark,
		materialName,
		productName,
		subtitle,
		url,
		variant = "default",
	} = props;
	const router = useRouter();

	return (
		<Tooltip
			hideOnTouchDevice
			className="p-2"
			content={
				<div className="flex flex-col gap-2">
					<div className="flex flex-wrap justify-between gap-x-4">
						<div className="font-bold">{materialName}</div>
						<div>{subtitle}</div>
					</div>

					{!!imageWatermark && (
						<Image
							width={310}
							height={155}
							alt={productName}
							src={imageWatermark}
							className="aspect-[2/1] object-cover"
						/>
					)}
				</div>
			}
		>
			<button
				type="button"
				className={cn("shrink-0 snap-start overflow-hidden rounded-full p-px", {
					"border-2 border-shades": variant === "default",
					"border-2 border-primary-medium": variant === "shades",
					"border-2 border-secondary": variant === "secondary",
				})}
				onClick={() => router.push(url)}
			>
				<Image
					width={24}
					height={24}
					alt={productName}
					src={image}
					className="h-6 w-6 rounded-full bg-shades object-cover lg:bg-shades-light"
				/>
			</button>
		</Tooltip>
	);
}
